import { Popup } from "devextreme-react/popup";
import ProcessingOfEmailAddressAcceptance from "./ProcessingOfEmailAddressAcceptance";
import ProcessingOfEmailAddressForFullTimeEmployeeContent from "./ProcessingOfEmailAddressForFullTimeEmployeeContent";

export default function ProcessingOfEmailAddressAcceptancePopup() {
  return (
    <Popup visible fullScreen showTitle={false} showCloseButton={false}>
      <ProcessingOfEmailAddressForFullTimeEmployeeContent />
      <ProcessingOfEmailAddressAcceptance />
    </Popup>
  );
}
